import React from "react";
import { Icon } from "../icons";
import { fmtDate, todayStr } from "../lib/format";
import { computeDailySummary } from "../lib/selectors";
import { useMcOps } from "../lib/McOpsContext";

export const DailySummaryModal = () => {
  const { state, summaryOpen, closeSummary, summarySent, sendSummary } = useMcOps();
  if (!summaryOpen) return null;
  const s = computeDailySummary(state);

  const stats = [
    ["phone", "red", "Called — Not Confirmed", s.calledNotConfirmed],
    ["check", "green", "Called — Confirmed", s.calledConfirmed],
    ["reply", "blue", "Introduction Calls Completed", s.introCompleted],
    ["activity", "purple", "Moves In Progress", s.inProgressCount],
    ["phone", "amber", "Outbound / Inbound Calls", s.outboundCalls + " / " + s.inboundCalls],
    ["alert", "red", "Missed Calls", s.missedCalls],
    ["msg", "blue", "Texts Sent", s.textsSent],
    ["mail", "purple", "Emails Sent", s.emailsSent],
    ["alert", "amber", "Escalations Raised / Resolved", s.escalationsRaised + " / " + s.escalationsResolved],
    ["note", "green", "Notes Logged", s.notesLogged],
    ["bell", "amber", "Reminders Set", s.remindersLogged],
    ["clipboard", "blue", "Confirmation PDFs Generated", s.pdfGenerated],
  ];

  return (
    <div
      className="modal-overlay open"
      onClick={(e) => {
        if (e.target === e.currentTarget) closeSummary();
      }}
    >
      <div className="modal" style={{ maxWidth: 640 }}>
        <div className="modal-head">
          <div className="mh-left">
            <div className="mh-avatar" style={{ background: "var(--grad-primary)" }}>
              M
            </div>
            <div>
              <h3>Daily Activity Summary</h3>
              <div className="meta">
                {fmtDate(todayStr())} · Prepared for manager review
              </div>
            </div>
          </div>
          <button className="modal-close" onClick={closeSummary}>
            <Icon name="x" />
          </button>
        </div>

        <div className="modal-body">
          <div className={`summary-sent-banner${summarySent ? " show" : ""}`}>
            <Icon name="check" />
            Sent to manager — copy also saved to Notifications · Internal.
          </div>
          <div className="summary-paragraph">
            <Icon name="sparkle" /> {s.paragraph}
          </div>
          <div className="summary-grid">
            {stats.map(([ic, color, label, num]) => (
              <div className="summary-stat" key={label}>
                <div className={`stat-icon ${color}`}>
                  <Icon name={ic} />
                </div>
                <div>
                  <div className="num">{num}</div>
                  <div className="label">{label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="modal-foot">
          <button className="btn primary" type="button" onClick={sendSummary}>
            <Icon name="mail" />
            {summarySent ? "Re-send to Manager" : "Send to Manager"}
          </button>
          <button className="btn" type="button" onClick={closeSummary}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
